import { render, staticRenderFns } from "./InformationRegistModal.vue?vue&type=template&id=432e87e4&"
import script from "./InformationRegistModal.vue?vue&type=script&lang=js&"
export * from "./InformationRegistModal.vue?vue&type=script&lang=js&"
import style0 from "./InformationRegistModal.vue?vue&type=style&index=0&id=432e87e4&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports